<template>
  <div class="pageContainer app-container">
    <el-row class="flexStart">
      <el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">
        <el-option label="学生姓名" value="stu_name">学生姓名</el-option>
        <el-option label="学生编号" value="stu_code">学生编号</el-option>
      </el-select>
      <el-input v-model="searchForm.keyword" size="small" placeholder="请输入查询关键字"
                style="max-width: 200px;margin-right: 10px;" />


      <el-cascader ref="firstCascader" :options="treeData" :props="treeProps" size="small"
                   v-model="searchForm.dept_id" :show-all-levels="true" @change="handleCascaderChange" placeholder="组织"
                   style="min-width: 300px;margin-right: 10px;" filterable clearable></el-cascader>

      <el-select v-model="searchForm.status" size="small" placeholder="请选择"
                 style="width: 130px; margin-right: 10px;" @change="changeStatus">
        <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.value"></el-option>
      </el-select>
      <el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="onReset" type="warning">重置</el-button>
      <el-button size="small" icon="el-icon-finished" @click="sendMessages" type="primary">群发短信</el-button>
      <el-tooltip content="查看短信模板" placement="top" effect="light">
        <i class="el-icon-info" @click="showMessageTemp"
           style="color:#1890ff;;font-size: 20px; margin-left: 6px;"></i>
      </el-tooltip>
    </el-row>
    <el-col :span="24" class="tabContainer" style="margin-top: 20px;">
      <el-tabs v-model="activeName" type="border-card" style="height: 100%;">
        <el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">


          <el-table :data="tableData" size="mini" style="width: 100%;margin-bottom: 20px;" border @selection-change="handleSelectionChange" stripe>
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="index" width="55" label="序号">
              <template slot-scope="scope">
                {{scope.$index+1+((page.pageIndex-1)*page.pageSize)}}
              </template>
            </el-table-column>
            <el-table-column prop="stu_code" width="110" label="学号">
            </el-table-column>
            <el-table-column prop="stu_name" label="姓名" width="100"></el-table-column>

            <el-table-column prop="gender" label="性别" width="60">
              <template slot-scope="scope">

                <span v-if="scope.row.gender==1">男</span>
                <span v-if="scope.row.gender==2">女</span>

                <span v-if="scope.row.gender==0">未知</span>
              </template>
            </el-table-column>
            <el-table-column prop="graduate_sch_city" label="地区" width="150"></el-table-column>
            <el-table-column prop="yuanxi_name" label="系部" min-width="100"></el-table-column>
            <el-table-column prop="major_name" label="专业" min-width="100"></el-table-column>
            <el-table-column prop="class_name" label="班级" min-width="100"></el-table-column>

            <el-table-column prop="phone" label="联系方式" min-width="100"></el-table-column>
            <el-table-column prop="username" label="录入员" width="100"></el-table-column>



            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button icon="el-icon-message" @click="sendMessage(scope.row)" type="text" size="small">发送短信</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handlePageChange" :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, prev, pager, next, jumper"
                         :total="page.total">
          </el-pagination>

        </el-tab-pane>
      </el-tabs>
    </el-col>
  </div>
</template>
<script>
import api from '@/api/api';

export default {
  name: 'StuClass',
  components: {
  },
  data() {
    return {
      searchForm: {
        ktype: 'stu_name',
        status: 3
      },
      tabMapOptions: [{label: '未回复列表', key: 'CN'}],
      activeName: 'CN',
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'title',
        value: 'id',
        checkStrictly: true,
        emitPath: false,
      },

      tableData: [],
      statusList:[{name:'未发送',value:1},{name:'已发送',value:2},{name:'已发送未回复',value:3},{name:'已回复',value:4}],
      page: {
        pageIndex: 1,
        pageSize: 100,
        total: 0
      },
      multipleSelection: [],
    }
  },
  watch: {
    activeName(val) {
      this.$router.push(`${this.$route.path}?tab=${val}`)
    }
  },
  created() {
    // init the default selected tab
    const tab = this.$route.query.tab
    if (tab) {
      this.activeName = tab
    }
  },
  mounted() {
    this.getList();
    this.getOrgList();
  },
  methods: {
    getList() {
      this.tableData = [{
        class_name: '计算机1班',
        gender:1,
        graduate_sch_city: "江苏省,南京市,玄武区",
        major_name: "计算机网络技术",
        phone: "18100000000",
        stu_code: "20210000",
        stu_name: "李雷",
        username: "刘主任",
        yuanxi_name: "计算机管理系",
      }]
      this.page.total = 1
      return
      let params = Object.assign({
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        stu_type: "all",
        status: 3
      }, this.searchForm)
      if (this.searchForm.dept_id) {
        let val = this.searchForm.dept_id
        let type = this.$refs['firstCascader'].panel.getNodeByValue(val).data.node_type
        if (type == "dept") {
          params.xibu = this.$refs['firstCascader'].panel.getNodeByValue(val).label
        } else {
          params.zhuanye = this.$refs['firstCascader'].panel.getNodeByValue(val).label
        }

      }
      params.ktype = this.searchForm.ktype;
      params.keyword = this.searchForm.keyword;
      if (this.searchForm.ktype == 'stu_name') {
        params.stu_name = this.searchForm.keyword
      }

      this.$http.post(api.stuList, params).then(res => {
        for (let item of res.data.data) {
          let city = item.graduate_sch_city.split(",")
          if (city.length >= 3) {
            item.city = city[1]
          }
        }
        this.tableData = res.data.data
        this.page.total = res.data.page.count
      })
    },

    getOrgList() {
      let _this = this
      this.$http.post("/api/sch_major_list_and_num").then(res => {
        if (res.data && res.data.length > 0) {
          _this.deleteEmptyGroup(res.data).then(result => {
            this.treeData = result
          })
        }
      })
    },
    // 处理没有children的分组
    deleteEmptyGroup(treeData) {
      return new Promise(resolve => {
        function traversal(data) {
          data.map(item => {
            for (let info in item) {
              if (item['children']) {
                if (item['children'].length > 0) {
                  traversal(item['children'])
                }
                if (item['children'].length == 0) {
                  delete item['children']
                }
              }
            }
          })
        }

        traversal(treeData)
        resolve(treeData)
      })
    },
    changeStatus(e){
      console.log(e,this.statusList)
      let name = e ? this.statusList.find(ele => ele.value === e).name : ''
      this.tabMapOptions[0].label = name + '列表'
    },
    handlePageChange(e) {
      this.page.pageIndex = e
      this.getList()
    },
    handleSelectionChange(val) {
      let _this = this;
      _this.multipleSelection = val;
    },
    onSearch() {
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    onReset() {
      this.searchForm = {
        ktype: 'stu_name'
      };
      this.tableData = [];
      this.page.pageIndex = 1;
      this.getList();
    },
    handleCascaderChange(e, opt) {
      console.log(e, this.$refs['firstCascader'].panel.getNodeByValue(e))
    },
    showMessageTemp(){
        this.$alert('这是一段模板内容，这是一段模板内容，这是一段模板内容，这是一段模板内容，这是一段模板内容', '短信模板', {
          confirmButtonText: '确定',
          callback: action => {
           console.log('确定')
          }
        });
    },
    sendMessage(){
      this.$message.success('发送成功！')
    },
    sendMessages(){
      if(!this.multipleSelection||this.multipleSelection.length==0){
        this.$message.warning('请选择至少一个学生！')
        return
      }else {
        this.sendMessage()
      }
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.custom-tree-node{ font-size: 14px; }
</style>
